import React, { Fragment } from 'react';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as ArrowLeft } from '../../../../../../resources/assets/components/arrow-right-sm-dark.svg';
import { ReactComponent as OptionsIcon } from '../../../../../../resources/assets/components/DLS_MoreVertical.svg';
import { useIsXSmallResolution } from '../../../../../hooks/use-is-xsmall-resolution.js';
import { Modal } from '../../../../modal/modal.js';
import { Popover } from '../../../../popover/popover.js';
function renderTitle(onClick, parent) {
    if (parent) {
        const { action } = parent;
        const { text = '', onClick: onActionClick } = action;
        const onClickWrapper = () => {
            if (isFunction(onActionClick)) {
                onActionClick(new ClickEvent());
            }
            onClick();
        };
        return (React.createElement("div", { className: "c-heading-options__item", onClick: onClickWrapper },
            MessageService.translate(text),
            React.createElement(ArrowLeft, { className: "c-heading-options__item-arrow c-heading-action__icon-dark" })));
    }
    return (React.createElement("div", { className: "c-heading__options-icon c-heading-action__icon-dark" },
        React.createElement(OptionsIcon, { onClick: onClick })));
}
function getModalTitle(parent) {
    if (!parent) {
        return '';
    }
    const optionTitle = 'tws.contextual-bar.options';
    const { action } = parent;
    return action.text || optionTitle;
}
function InternalHeadingOptions(props) {
    const { children, onClose, onClick, open, parent } = props;
    const isXSmallResolution = useIsXSmallResolution();
    const isModalCloseable = !Modal.hasApplicationBar() || isXSmallResolution;
    if (!children) {
        return null;
    }
    if (!isXSmallResolution) {
        return (React.createElement(Popover, { className: "c-heading-options__popover", onClose: onClose, open: open, showArrow: true },
            renderTitle(onClick, parent),
            React.createElement(Popover.Content, null, children)));
    }
    return (React.createElement(Fragment, null,
        renderTitle(onClick, parent),
        open ? (React.createElement(Modal, { closeable: isModalCloseable, focusOnOpen: false, noPadding: true, onClose: onClose, title: getModalTitle() }, children)) : null));
}
export { InternalHeadingOptions, };
//# sourceMappingURL=internal-heading-options.js.map